<template>
  <div class="experiment ma-0">
    <v-row v-if="current.user_level=='ADMIN'">
      <v-col>
        <v-select v-if="$i18n.locale=='tc'"
          :items="api.schools"
          item-text="id_chi_name"
          item-value="school_id"
          v-model="form.school_id"
          label="School"
          :disabled="current.user_level!='ADMIN'"
          @change="goTo(form.school_id)"
        ></v-select>
        <v-select v-else
          :items="api.schools"
          item-text="id_name"
          item-value="school_id"
          v-model="form.school_id"
          label="School"
          :disabled="current.user_level!='ADMIN'"
          @change="goTo(form.school_id)"
        ></v-select>
      </v-col>
    </v-row>
    <div class='mt-5 mb-2 title d-flex'>
      <span><v-img width="30px" :src='api.school_logo_url' /></span>
      <span v-if="$i18n.locale=='tc'" class='ml-2'> {{ api.school_chi_name }} </span>
      <span v-else class='ml-2'> {{ api.school_name }} </span>
      <span class="ml-auto">
        <v-btn color="light-green lighten-3" @click="dialog_calendar = true; componentKey+=1">
          <v-icon>mdi-calendar</v-icon>
          {{ $t("booking.calendar_btn") }}
        </v-btn>
      </span>
    </div>
    <v-row class="mx-3">
      <v-spacer></v-spacer>
      
    </v-row>
    <v-expansion-panels class="my-3" v-model="panel" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header color="green lighten-5">
          <h5>Ongoing Group Experiment</h5>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col>
              <v-card class="mx-auto" max-width="350px">
                <v-img 
                  height="320px"
                  class="d-flex align-end"
                  cover
                  src="https://labxra.edu.hk/remotelab/api/iot/experiment/storage/POLYU-AP-PHOTOSYNTHESIS-set_1/gp_exp-1/photo_1764310037.jpeg"
                >
                  <div class="d-flex align-end" style="background: rgba(0,0,0,0.4);">
                    <v-card-text class="white--text p-2">
                      Photo taken: 2025-11-28 5:35 pm
                    </v-card-text>
                  </div>
                </v-img>

                <v-card-title>
                  Photosynthesis - set_1
                </v-card-title>

                <div class="text-body-2 pl-6 mt-n4">
                  <table>
                    <tr>
                      <td>Start: </td>
                      <td class="pl-2">2025-11-27, 07:00 pm</td>
                    </tr>
                    <tr>
                      <td>End: </td>
                      <td class="pl-2">2025-11-29, 00:00 am</td>
                    </tr>
                  </table>
                </div>

                <v-card-actions>
                  <v-btn v-if="!api.group_experiment_slot[0].show" rounded text @click="api.group_experiment_slot[0].show = !api.group_experiment_slot[0].show">See More<v-icon>mdi-chevron-down</v-icon></v-btn>
                  <v-btn v-else rounded text @click="api.group_experiment_slot[0].show = !api.group_experiment_slot[0].show">Show Less<v-icon>mdi-chevron-up</v-icon></v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" class="p-3">
                    Enter Lab
                  </v-btn>
                </v-card-actions>

                <v-expand-transition>
                  <div v-show="api.group_experiment_slot[0].show">
                    <v-divider class="mt-2 mx-5"></v-divider>
                    <v-card-text class="pt-0 text-body-1 font-weight-bold">
                      Experiment Setting:
                      <div class="text-body-2 px-auto">
                        <table>
                          <tr style="border-bottom: 1px solid lightgrey;">
                            <td>Location: </td>
                            <td class="pl-2">CD705</td>
                          </tr>
                          <tr style="border-bottom: 1px solid lightgrey;">
                            <td>Plant: </td>
                            <td class="pl-2">Marimo (毬藻)</td>
                          </tr>
                          <tr style="border-bottom: 1px solid lightgrey;">
                            <td>Light Change: </td>
                            <td class="pl-2">every 6 hours</td>
                          </tr>
                          <tr style="border-bottom: 1px solid lightgrey;">
                            <td>Light Sequence: </td>
                            <td class="pl-2">Green>Red>Blue </td>
                          </tr>
                          <tr style="border-bottom: 1px solid lightgrey;">
                            <td>Water Temperature: </td>
                            <td class="pl-2">25 degree C</td>
                          </tr>
                        </table>
                      </div>
                    </v-card-text>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="mx-auto" max-width="350px">
                <v-img 
                  height="320px"
                  class="d-flex align-end"
                  cover
                  src="https://labxra.edu.hk/remotelab/api/iot/experiment/storage/POLYU-AP-PHOTOSYNTHESIS-set_1/gp_exp-1/photo_1764315037.jpeg"
                >
                  <div class="d-flex align-end " style="background: rgba(0,0,0,0.4);">
                    <v-card-text class="white--text p-2">
                      Photo taken: 2025-11-28 5:35 pm
                    </v-card-text>
                  </div>
                </v-img>

                <v-card-title>
                  Respiration - set_1
                </v-card-title>

                <div class="text-body-2 pl-6 mt-n4">
                  <table>
                    <tr>
                      <td>Start: </td>
                      <td class="pl-2">2025-11-28, 01:00 pm</td>
                    </tr>
                    <tr>
                      <td>End: </td>
                      <td class="pl-2">2025-11-30, 00:00 am</td>
                    </tr>
                  </table>
                </div>

                <v-card-actions>
                  <v-btn v-if="!api.group_experiment_slot[1].show" rounded text @click="api.group_experiment_slot[1].show = !api.group_experiment_slot[1].show">See More<v-icon>mdi-chevron-down</v-icon></v-btn>
                  <v-btn v-else rounded text @click="api.group_experiment_slot[1].show = !api.group_experiment_slot[1].show">Show Less<v-icon>mdi-chevron-up</v-icon></v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" class="p-3">
                    Enter Lab
                  </v-btn>
                </v-card-actions>

                <v-expand-transition>
                  <div v-show="api.group_experiment_slot[1].show">
                    <v-divider class="mt-2 mx-5"></v-divider>
                    <v-card-text class="pt-0 text-body-1 font-weight-bold">
                      Experiment Setting:
                      <div class="text-body-2 px-auto">
                        <table>
                          <tr style="border-bottom: 1px solid lightgrey;">
                            <td>Location: </td>
                            <td class="pl-2">CD705</td>
                          </tr>
                          <tr style="border-bottom: 1px solid lightgrey;">
                            <td>Plant: </td>
                            <td class="pl-2">Marimo (毬藻)</td>
                          </tr>
                          <tr style="border-bottom: 1px solid lightgrey;">
                            <td>Light Change: </td>
                            <td class="pl-2">every 4 hours</td>
                          </tr>
                          <tr style="border-bottom: 1px solid lightgrey;">
                            <td>Light Sequence: </td>
                            <td class="pl-2">Violet>Green>Orange>Blue>Red </td>
                          </tr>
                          <tr style="border-bottom: 1px solid lightgrey;">
                            <td>Water Temperature: </td>
                            <td class="pl-2">24.3 degree C</td>
                          </tr>
                        </table>
                      </div>
                    </v-card-text>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="mx-auto" max-width="350px">
                <v-img 
                  height="320px"
                  class="d-flex align-end"
                  cover
                  src="https://labxra.edu.hk/remotelab/api/iot/experiment/storage/POLYU-AP-PHOTOSYNTHESIS-set_1/gp_exp-1/photo_1764320037.jpeg"
                >
                  <div class="d-flex align-end " style="background: rgba(0,0,0,0.4);">
                    <v-card-text class="white--text p-2">
                      Photo taken: 2025-11-28 5:35 pm
                    </v-card-text>
                  </div>
                </v-img>

                <v-card-title>
                  Respiration - set_2
                </v-card-title>

                <div class="text-body-2 pl-6 mt-n4">
                  <table>
                    <tr>
                      <td>Start: </td>
                      <td class="pl-2">2025-11-28, 01:00 pm</td>
                    </tr>
                    <tr>
                      <td>End: </td>
                      <td class="pl-2">2025-11-30, 00:00 am</td>
                    </tr>
                  </table>
                </div>

                <v-card-actions>
                  <v-btn v-if="!api.group_experiment_slot[2].show" rounded text @click="api.group_experiment_slot[2].show = !api.group_experiment_slot[2].show">See More<v-icon>mdi-chevron-down</v-icon></v-btn>
                  <v-btn v-else rounded text @click="api.group_experiment_slot[2].show = !api.group_experiment_slot[2].show">Show Less<v-icon>mdi-chevron-up</v-icon></v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" class="p-3">
                    Enter Lab
                  </v-btn>
                </v-card-actions>

                <v-expand-transition>
                  <div v-show="api.group_experiment_slot[2].show">
                    <v-divider class="mt-2 mx-5"></v-divider>
                    <v-card-text class="pt-0 text-body-1 font-weight-bold">
                      Experiment Setting:
                      <div class="text-body-2 px-auto">
                        <table>
                          <tr style="border-bottom: 1px solid lightgrey;">
                            <td>Location: </td>
                            <td class="pl-2">CD705</td>
                          </tr>
                          <tr style="border-bottom: 1px solid lightgrey;">
                            <td>Plant: </td>
                            <td class="pl-2">Marimo (毬藻)</td>
                          </tr>
                          <tr style="border-bottom: 1px solid lightgrey;">
                            <td>Light Change: </td>
                            <td class="pl-2">every 4 hours</td>
                          </tr>
                          <tr style="border-bottom: 1px solid lightgrey;">
                            <td>Light Sequence: </td>
                            <td class="pl-2">Violet>Green>Orange </td>
                          </tr>
                          <tr style="border-bottom: 1px solid lightgrey;">
                            <td>Water Temperature: </td>
                            <td class="pl-2">24.3 degree C</td>
                          </tr>
                        </table>
                      </div>
                    </v-card-text>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header color="green lighten-5">
          <h5>{{ $t("booking.opened_experiment.expansion") }}</h5>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col>
              <v-select v-if="0"
                :items="api.schools"
                item-text="school_id"
                item-value="school_id"
                v-model="form.school_id"
                label="School"
                @change="getBookSlots(form.school_id)"
                disabled
              ></v-select>
            </v-col>
          </v-row>
          <v-data-table
            v-if="$i18n.locale=='tc'"
            :locale="localeTranslate()"
            dense 
            :headers="headers_book_slots_chi"
            :items="api.book_slots"
            item-key="id"
            :items-per-page="-1"
            no-data-text="沒有適用的實驗組">
          </v-data-table>          
          <v-data-table
            v-else
            dense
            :locale="localeTranslate()"
            :headers="headers_book_slots"
            :items="api.book_slots"
            item-key="id"
            :items-per-page="-1"
            no-data-text="No Experiment Available ">
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog v-model="dialog_calendar" fullscreen hide-overlay>
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="dialog_calendar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("booking.calendar.dialog_title") }}</v-toolbar-title>
          <!--v-spacer></v-spacer-->
        </v-toolbar>
        <Calendar :key="componentKey" :schoolName="api.school_name" :schoolChiName="api.school_chi_name"  :schoolLogoUrl="api.school_logo_url" />
      </v-card>
    </v-dialog>
    <router-view @info="schoolInfo" :key="childrenKey" :par="par" ref="mab"></router-view>
  </div>
</template>
<script>
import moment from "moment";

import {api_booking} from '@/services/iot/api_booking';
const apiBooking = new api_booking(process.env.VUE_APP_BASE_URL);

import {api_general} from '@/services/iot/api_general';
const apiGeneral = new api_general(process.env.VUE_APP_BASE_URL);

import {api_management} from '@/services/iot/api_management';
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);

import Calendar from '@/components/booking/Calendar.vue'

export default {
  name: "experiment",
  components: {
    Calendar
  },
  mixins: [],
  data: function () {
    return {
      par: "this is pars",
      componentKey: 0,
      childrenKey: 0,
      panel: [0],
      school_id: "",
      role: null,
      drawer: true,
      mini: true,
      dialog: false,
      dialog_calendar: false,
      current:{
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
        experiment: null,
        equipment_id: null,
      },
      form: {
        school: "",
        experiment: "",
        equipment_id: "",
        next: "",
      },
      api:{
        group_experiment_slot: [{"show": false}, {"show": false}, {"show": false}],
        schools:[],
        experiments:[{field: "BIOLOGY", experiment: "BACTERIA_GROWTH", experiment_name: "Bacteria Growth", status: "ACTIVE",create_at: "2022-09-06 15:55:17"}],
        experiments_list:[],
        book_slots: [],
        slots: [],
        school_id: '',
        school_name: '',
        school_chi_name: '',
        school_logo_url: '',
      },
      headers_slots: [
        { text: 'Ref', value: 'ref' },
        { text: 'Experiment Set', value: 'experiment_set' },
        { text: 'From', value: 'start_at' },
        { text: 'To', value: 'end_at' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false },        
      ],
      headers_slots_chi: [
        { text: '參考編號', value: 'ref' },
        { text: '實驗組', value: 'experiment_set_chi' },
        { text: '開始', value: 'start_at' },
        { text: '結束', value: 'end_at' },
        { text: '狀態', value: 'status_chi' },
        { text: '操作', value: 'actions', sortable: false },        
      ],
      headers_book_slots: [
        { text: 'Ref', value: 'ref' },
        { text: 'Experiment Set', value: 'experiment_set' },
        { text: 'Date', value: 'date' },
        { text: 'Time', value: 'time' },
        { text: 'Duration (mins)', value: 'duration' },
        { text: 'Status', value: 'status' },
        { text: 'Update At', value: 'update_at' },
        //{ text: 'Actions', value: 'actions', sortable: false },        
      ],
      headers_book_slots_chi: [
        { text: '參考編號', value: 'ref' },
        { text: '實驗組', value: 'experiment_set_chi' },
        { text: '日期', value: 'date' },
        { text: '時間', value: 'time' },
        { text: '時長(分鐘)', value: 'duration' },
        { text: '狀態', value: 'status_chi' },
        { text: '最後更新', value: 'update_at' },
        //{ text: 'Actions', value: 'actions', sortable: false },        
      ],
    };
  },
  created: function () {
    //addEventListener("beforeunload", this.beforeUnloadListener, { capture: true });
  },
  mounted: function () {
    var self = this;
    self.init();
  },
  methods: {
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    init(){
      var self = this;
      self.current.school_id = self.$store.state.user.school_id;
      self.current.username = self.$store.state.user.username;
      self.current.user_level = self.$store.state.user.user_level;
      self.current.auth_token = self.$store.state.user.auth_token;
      if(self.current.user_level == "USER"){
        //self.panel = "1";
      }
      if(self.current.user_level != "ADMIN" ){
        self.api.schools = [self.current.school_id];
        self.form.school_id = self.current.school_id;
        self.getUserSchool();
      }
      else {
        self.getSchoolList();
        if(self.$route.params.school_id == undefined){
          self.form.school_id = self.current.school_id;
          self.$router.push("/group_experiment/"+self.current.school_id);
        }
        else {
          self.form.school_id = self.$route.params.school_id;
          self.$router.push("/group_experiment/"+self.form.school_id);
        }
      }
  //    self.school_id = self.$route.params.school_id;    
  //    self.form.school = self.school_id;
      self.getSchoolExperiment();    
      self.getExperimentList();
      self.getOngoingBookSlotsByUserRight(self.form.school_id);
      self.getMyFutureBooking(self.current.username, self.current.school_id);
    },
    schoolInfo({school_id, school_name, school_chi_name, school_logo_url}){
      var self = this;
      self.api.school_id = school_id;
      self.api.school_name = school_name;
      self.api.school_chi_name = school_chi_name;
      self.api.school_logo_url = school_logo_url;
    },
    getUserSchool(){
      var self = this;
      apiGeneral.getUserSchool(self.$cookies.get('username')).then((response) => {
        if(response.status=="success" && self.$route.params.school_id!=response.school){
          self.$router.push("/group_experiment/"+response.school+"/");
        }
      });
    },
    isBookedByMe: function (slot) {
      if ( (slot.current==true && (slot.status == "RESERVED"||slot.status == "SUSPENDED") && (slot.username == this.$cookies.get("username"))) ) {
        return true;
      }
      else {
        return false;
      }
    },    
    isOverrided(slot){
      if (slot.eStatus=="HOLD" && !slot.passed) {
        return true;
      } 
      else {
        return false;
      }
    },
    isBookedSoon: function (slot) {
      if ( slot.current==false && ( slot.status == "RESERVED" || slot.status == "SUSPENDED" || slot.status == "MAINTENANCE") && slot.username == this.$cookies.get("username") ) {
        return true;
      }
      else {
        return false;
      }
    },
    enterLab: function (slot_id, experiment, equipment_id, role, override, user_level) {
      var self = this;
      if(override == "1" && role == "player"){
        self.$store.commit("showSnackBar", "This Booking is overriding by incharge/admin, please try entering later.");        
      }
      else {
        apiBooking
          .enterLab(slot_id, self.current.username, self.current.school_id, experiment, equipment_id, self.$cookies.get("auth_token"), role, user_level)
          .then((response) => {
            if (response.status == "fail") {
              self.$store.commit("showSnackBar", response.message);
            } else {
              if(self.$i18n.locale=='tc')
                self.$store.commit("showSnackBar", "準備中...");
              else
                self.$store.commit("showSnackBar", "Preparing...");
              console.log(response);            
              self.$cookies.set("session_token", response.session_token);
              self.$cookies.set("role", role);
              self.$cookies.set("school_id", self.current.school_id);
              self.$cookies.set("experiment", experiment);
              self.$cookies.set("equipment_id", equipment_id);
              self.$cookies.set("end_at", response.end_at);
              self.$cookies.set("booking_id", slot_id);
              self.$router.push(
                "/iot_experiment/" + self.current.school_id + "/" + experiment.toLowerCase() + "/" + equipment_id
              );
            }
          });
      }
    },
    releaseSlot: function (slot_id) {
      var self = this;
      apiBooking
        .releaseSlot(slot_id, self.$cookies.get("auth_token"))
        .then((response) => {          
          if (response.status == "fail") {
            self.$store.commit("showSnackBar", response.message);
          } else {
            self.$store.commit("showSnackBar", "Booking Cancelled");
            //location.reload();
            self.$refs.mab.getSlotsByDate();
            self.getMyFutureBooking(self.current.username, self.current.school_id);
          }
        });
    },
    getSchoolList(){
      var self = this;
      apiGeneral.getSchoolList()
      .then((response) => {
        self.api.schools = response.schools;
      });
    },
    getSchoolExperiment(){
      var self = this;
      apiManagement.getSchoolExperiment(self.form.school_id)
      .then((response) => {
          self.api.experiments = response.experiments;          
      });
    },
    getExperimentList(){
      var self = this;
      apiManagement.getExperimentList()
      .then((response) => {
          self.api.experiments_list = response.experiments;
      });
    },
    getMyFutureBooking(username, school_id){
      var self = this;
      apiBooking.getMyFutureBooking(username, school_id)
      .then((response) => {
          self.api.slots = response.slots;
      });
    },
    getOngoingBookSlots(school_id){
      var self = this;
      apiGeneral.getOngoingBookSlots(school_id)
      .then((response) => {
          self.api.book_slots = response.book_slots;
      });
    },    
    getOngoingBookSlotsByUserRight(school_id){
      var self = this;
      apiGeneral.getOngoingBookSlotsByUserRight(school_id, self.current.username)
      .then((response) => {
          self.api.book_slots = response.book_slots;
      });
    },
    viewBookSlots(item){
      var self = this;
      self.$cookies.set('experiment', item.experiment);
      self.equipment_id = self.$cookies.set('equipment_id', item.equipment_id);
      self.$router.push("/school/history/"+self.school_id+"/"+item.experiment+"/"+item.equipment_id);
    },
    back(){
      var self = this;
      self.$cookies.remove("experiment");
      self.$cookies.remove("equipment_id");
      if(self.$route.name == 'admin-school-management'){
        self.$router.push("/admin/management/school/school_list");
      }
      else {
        self.$router.push("/school/school_list");
      }
    },
    goTo(school_id){
      var self = this;
      self.$router.push("/group_experiment/"+school_id);
      self.init();      
      self.componentKey+=1;
      self.childrenKey+=1;
    },
    /*beforeUnloadListener(event) {
      console.log("beforeUnloadListener");
      event.preventDefault();
      return (event.returnValue = "qwer");
    },
    beforeUnloadListener2(event) {
      console.log("beforeUnloadListener2");
      event.preventDefault();
      return (event.returnValue = "");
    },*/
  },
  beforeDestroy() {
  /*  alert("beforeDestroy");
    removeEventListener("beforeunload", this.beforeUnloadListener2, {
      capture: true,
    });
    */
  },
  destroyed(){
    clearInterval(this.kick_inte);
    console.log("destroyed");
  }
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}


v-btn {
  text-transform: none;
}
</style>